import React from 'react'

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import styled from 'styled-components';


const WidgetChart = styled.div`
     /* overflow-x: auto; */
    .recharts-responsive-container{
        transform: translateX(-40px);
    }

    .recharts-default-tooltip{
        margin: 0px;
        padding: var(--smallPads);
        border-radius: var(--smallRadius);
        /* background-color: rgb(196, 0, 0) !important; */
        background-color: ${p=>p.theme.low} !important;
        border: 1px solid rgb(204, 204, 204);
        white-space: nowrap;

        span{
            font-size: 1.5rem;
        }
    }
`
export default function Widget_Chart(props) {

    const chartData = Object.entries(props.kpiData).map(([month, data]) => ({
        month: month.slice(2), 
        activeTotal: data.activeTotal,
      }));

  return (
    <WidgetChart>
        <ResponsiveContainer width="100%" height={200}>
            <LineChart data={chartData} margin={{ top: 5, right: 0, bottom: 5, left: 0 }}>
                {/* <CartesianGrid strokeDasharray="1 3" /> */}
                <XAxis 
                    dataKey="month" 
                    angle={-45} 
                    textAnchor="end" 
                    interval={Math.floor(chartData.length / 6)} // only show ~6 ticks max
                />
                <YAxis />
                <Tooltip formatter={(value) => [`${value}`, 'Active Total']} />
                <Line type="monotone" dataKey="activeTotal" stroke={'var(--main)'} strokeWidth={2} />
            </LineChart>
        </ResponsiveContainer>
    </WidgetChart>
  )
}
